import React, { useRef, useState } from "react"
import { useSelector } from "react-redux"
import SupportIconWhite from '../../../../../assests/header/icons/support-icon-white.png'
import SupportIconDark from '../../../../../assests/header/icons/support-icon-dark.png'
import useClickOutside from "../../../../../hooks/useClickOutside"
import Support from "../../HeaderDashboard/Support"
import IconHeaderBackground from "../IconHeaderBackground"
import classes from '../Icons.module.css'
import { onKeyDown } from "../../../../../service"


const SupportBtn = () => {

    const [showSupport, setShowSupport] = useState(false)
    const texts = useSelector(state => state.translate.texts);
    const popupRef = useRef(null);

    useClickOutside(popupRef, () => {
        setShowSupport(false);
    });

    function open(e) {
        setShowSupport(prevShowSupport => !prevShowSupport)
    }

    return (
        <div ref={popupRef} className={` ${!showSupport ? classes.Icon : classes.OpenIconImg}`}>
            <img src={` ${showSupport ? SupportIconDark : SupportIconWhite}`} alt='SupportIcon' className={classes.IconImg} onClick={(e) => open(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => open(e))} />
            {showSupport && <IconHeaderBackground title={texts.support} close={() => setShowSupport(false)}><Support /></IconHeaderBackground>}
        </div>
    )
}

export default SupportBtn